import { getAllAdmins } from 'api/admin/admin';
import { getProfile } from 'api/admin/profile';
import { getDivisionInStorage, setNavigationInStorage } from 'lib/Storage';
import { useDivisionSetSate } from 'providers/DivisionProvider';
import { useUserState } from 'providers/UserProvider';
import { useQuery } from 'react-query';

function useAdmins() {
  return useQuery('admins', getAllAdmins);
}

function useProfile() {
  const [, setUser] = useUserState();
  const setDivision = useDivisionSetSate();
  const localDivision = getDivisionInStorage();

  return useQuery('profile', getProfile, {
    onSuccess: (data) => {
      const navigations = Array.isArray(data?.navigations) ? data.navigations : [];
      setNavigationInStorage(navigations);
      setUser((currentUser) => ({ ...currentUser, ...data?.admin, navigations }));
      if (localDivision) {
        setDivision({ ...localDivision, all: data?.divisions });
      } else {
        setDivision({ selected: data?.divisions[0], all: data?.divisions });
      }
    },
  });
}
export { useAdmins, useProfile };
